<div class="option-text">{{PersonType.Name}} </div>

<div class="edit-button">
    <button
        [Disabled]="isButtonDisabled"
        app-round-button
        matTooltip="Bearbeiten"
        matTooltipPosition="left"
        (click)="$event.stopPropagation(); onEditClick(PersonType)"
    >
        <fa-icon icon="pencil-alt"></fa-icon>
    </button>
</div>
